const normalizeText = (value) => String(value ?? "").trim();

const firstNonEmpty = (...values) => {
	for (const value of values) {
		const text = normalizeText(value);
		if (text) return text;
	}

	return "";
};

export const isProcessingSummaryStatus = ({
	isProcessingRow = false,
	pipelineStatusText = "",
	loganStatusText = "",
} = {}) => {
	if (isProcessingRow) {
		return true;
	}

	return [pipelineStatusText, loganStatusText]
		.map((value) => normalizeText(value).toLowerCase())
		.some((value) => value === "processing");
};

export const getDocumentPipelineStatusPresentation = ({
	row = {},
	isIndexed = false,
	indexedRecordTitle = "",
	isXpanseProcessingRecord = false,
	matchingConditionCount = 0,
	hasMatchingAttachment = false,
	hasAssignedTo = false,
	isPendingRetryRecord = false,
}) => {
	if (isPendingRetryRecord) {
		return {
			isIndexedDocument: false,
			isPendingUpdateToLoanFile: true,
			loganStatusText: "Pending Update To Loan File",
			encompassDocStatusText: "Pending Update To Loan File",
			pipelineDotColors: ["#F4BE3D", "#F4BE3D", "#D9DDE3", "#D9DDE3"],
			pipelineStatusText: "Processing",
			isYellowLoganStatus: true,
		};
	}

	const directPipelineStatus = firstNonEmpty(
		row?.pipelineStatus,
		row?.statusLabel,
		row?.assignedTo?.statusLabel,
		row?.eFolderStatus,
		row?.folderStatus,
		row?.indexStatus
	)
		.toLowerCase()
		.trim();
	const hasMatchedConditions = matchingConditionCount > 0;
	const isIndexedDocument = isIndexed || directPipelineStatus === "indexed";
	const isPendingUpdateToLoanFile =
		Boolean(firstNonEmpty(row?.id, row?.entityId, row?.documentId)) &&
		!hasMatchingAttachment;

	const loganStatusText = hasMatchedConditions
		? "Fully Received By Logan"
		: isPendingUpdateToLoanFile
			? "Fully Received By Logan"
			: isIndexedDocument
				? "Fully Received By Logan"
				: isXpanseProcessingRecord
					? "Fully Received By Logan"
					: hasAssignedTo
						? "Fully Received By Logan"
						: matchingConditionCount > 0
							? "Pending Index"
							: "Processing";

	const pipelineDotColors = hasMatchedConditions
		? ["#6FCF97", "#6FCF97", "#6FCF97", "#6FCF97"]
		: isPendingUpdateToLoanFile
			? ["#F4BE3D", "#F4BE3D", "#D9DDE3", "#D9DDE3"]
			: isIndexedDocument
				? ["#6FCF97", "#6FCF97", "#6FCF97", "#D9DDE3"]
				: isXpanseProcessingRecord
					? ["#F4BE3D", "#F4BE3D", "#D9DDE3", "#D9DDE3"]
					: {
							"Fully Received By Logan": [
								"#6FCF97",
								"#6FCF97",
								"#6FCF97",
								"#6FCF97",
							],
							"Conditions Matched": [
								"#6FCF97",
								"#6FCF97",
								"#6FCF97",
								"#6FCF97",
							],
							"Pending Update To Loan File": [
								"#F4BE3D",
								"#F4BE3D",
								"#D9DDE3",
								"#D9DDE3",
							],
							Processing: ["#F4BE3D", "#D9DDE3", "#D9DDE3", "#D9DDE3"],
							"Pending Index": ["#F4BE3D", "#F4BE3D", "#D9DDE3", "#D9DDE3"],
						}[loganStatusText] || ["#D9DDE3", "#D9DDE3", "#D9DDE3", "#D9DDE3"];

	const pipelineStatusText = hasMatchedConditions
		? "Conditions Matched"
		: isPendingUpdateToLoanFile
			? "Uploaded"
			: isIndexedDocument
				? "Indexed"
				: isXpanseProcessingRecord
					? "Uploaded"
					: {
							"Fully Received By Logan": "Matched",
							"Conditions Matched": "Conditions Matched",
							"Pending Update To Loan File": "Processing",
							Processing: "Processing",
							"Pending Index": "Uploaded",
						}[loganStatusText] || "Processing";

	const isYellowLoganStatus =
		loganStatusText === "Processing" ||
		loganStatusText === "Pending Index" ||
		loganStatusText === "Pending Update To Loan File";

	return {
		isIndexedDocument,
		isPendingUpdateToLoanFile,
		loganStatusText,
		encompassDocStatusText: isPendingUpdateToLoanFile
			? "Pending Index"
			: isIndexedDocument
				? normalizeText(indexedRecordTitle || "title")
				: isXpanseProcessingRecord
					? "Pending Index"
					: hasAssignedTo
						? normalizeText(row?.assignedTo?.entityName ?? " ")
						: "Pending",
		pipelineDotColors,
		pipelineStatusText,
		isYellowLoganStatus,
	};
};
